__turbopack_context__.v({
  "externalIcon": "headerLinkItem-module-scss-module__qCy0PW__externalIcon",
  "externalLink": "headerLinkItem-module-scss-module__qCy0PW__externalLink",
  "headerLinkItemContainer": "headerLinkItem-module-scss-module__qCy0PW__headerLinkItemContainer",
  "open": "headerLinkItem-module-scss-module__qCy0PW__open",
  "toggleIcon": "headerLinkItem-module-scss-module__qCy0PW__toggleIcon",
  "toggleIconWrapper": "headerLinkItem-module-scss-module__qCy0PW__toggleIconWrapper",
});
